import io from "socket.io-client";

class SocketWorker {
  constructor(companyId, userId) {
    // Se uma instância já existe para um usuário/empresa diferente, desconecte-a antes de criar uma nova.
    if (
      SocketWorker.instance &&
      (SocketWorker.instance.companyId !== companyId ||
        SocketWorker.instance.userId !== userId)
    ) {
      SocketWorker.instance.disconnect();
    }

    if (!SocketWorker.instance) {
      this.companyId = companyId;
      this.userId = userId;
      this.socket = null;
      this.eventListeners = {}; // Iniciar ANTES do configureSocket
      this.configureSocket();
      SocketWorker.instance = this;
    }

    return SocketWorker.instance;
  }

  get connected() {
    return this.socket ? this.socket.connected : false;
  }

    configureSocket() {
    if (!this.companyId || this.companyId === "undefined" || this.companyId === "null") {
      return; // Trava a conexão fantasma na origem
    }

    // Pega o token diretamente do localStorage para maior confiabilidade.
    const token = localStorage.getItem("token");
    const rawToken = token ? JSON.parse(token) : null;
    if (!rawToken) return;
    
    this.socket = io(`${process.env.REACT_APP_BACKEND_URL}/${this?.companyId}`, {
      autoConnect: true,
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: Infinity,
      transports: ["websocket", "polling"],
      pingTimeout: 18000,
      pingInterval: 18000,
      query: { userId: this.userId, token: rawToken },
    });

    // Restaura os eventListeners que os componentes React adicionaram antes do socket conectar
    if (this.eventListeners) {
      Object.keys(this.eventListeners).forEach((event) => {
        this.eventListeners[event].forEach((callback) => {
          this.socket.on(event, callback);
        });
      });
    }

    this.socket.on("connect", () => {
      console.log("Conectado ao servidor Socket.IO");
    });

    this.socket.on("disconnect", (reason) => {
      console.log("Desconectado do servidor Socket.IO:", reason);
      if (reason === "io server disconnect") {
        this.reconnectAfterDelay();
      }
    });
  }

  // Adiciona um ouvinte de eventos
  on(event, callback) {
    this.connect();
    if (this.socket) {
      this.socket.on(event, callback);
    }

    // Armazena o ouvinte no objeto de ouvintes
    if (!this.eventListeners[event]) {
      this.eventListeners[event] = [];
    }
    if (!this.eventListeners[event].includes(callback)) {
      this.eventListeners[event].push(callback);
    }
  }

  // Emite um evento
  emit(event, data) {
    this.connect();
    if (this.socket) {
      this.socket.emit(event, data);
    }
  }

  // Desconecta um ou mais ouvintes de eventos
  off(event, callback) {
    if (this.eventListeners[event]) {
      if (callback) {
        // Desconecta um ouvinte específico
        if (this.socket) this.socket.off(event, callback);
        this.eventListeners[event] = this.eventListeners[event].filter(
          (cb) => cb !== callback
        );
      } else {
        // Desconecta todos os ouvintes do evento
        if (this.socket) {
          this.eventListeners[event].forEach((cb) => this.socket.off(event, cb));
        }
        delete this.eventListeners[event];
      }
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      // Reseta corretamente a propriedade estática da instância na classe
      SocketWorker.instance = null;
      console.log("Socket desconectado manualmente");
    }
  }

  reconnectAfterDelay() {
    setTimeout(() => {
      if (!this.socket || !this.socket.connected) {
        console.log("Tentando reconectar após desconexão forçada pelo servidor...");
        
        const token = localStorage.getItem("token");
        const rawToken = token ? JSON.parse(token) : null;

        // 1. Se não há token, o usuário foi deslogado. Evita o loop infinito.
        if (!rawToken) {
          console.log("Token ausente. Abortando reconexão.");
          return;
        }

        // 2. Atualiza a query com o token para não enviar um token expirado
        if (this.socket) {
          // Se o token é exatamente o mesmo que o servidor acabou de rejeitar,
          // abortamos a reconexão. Tentar de novo com o mesmo token geraria loop.
          if (this.socket.io.opts.query.token === rawToken) {
            console.log("Token inalterado e rejeitado pelo servidor. Abortando loop de reconexão.");
            return;
          }
          this.socket.io.opts.query = { userId: this.userId, token: rawToken };
        }

        this.connect();
      }
    }, 2000);
  }

  // Garante que o socket esteja conectado
  connect() {
    if (!this.socket) {
      this.configureSocket();
    } else if (!this.socket.connected) {
      this.socket.connect();
    }
  }
}

const instance = (companyId, userId) => new SocketWorker(companyId, userId);

export default instance;